// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los distintos valores que hay en la alfombra
 * @param {*} scene
 */
export function cargaAssetsValoresAlfombra(scene) {

  // Numeros alfombra
  for (let i = 0; i <= 36; i++) {
    scene.load.image(
      `valorAlfombra${i.toString()}`,
      ROUTES.rutaRuletaValoresAlfombraNumeros +
        `/valorAlfombra${i.toString()}Resized.png`
    );
    scene.load.image(
      `valorAlfombra${i.toString()}Hover`,
      ROUTES.rutaRuletaValoresAlfombraNumeros +
        `/valorAlfombra${i.toString()}HoverResized.png`
    );
  }

  // Chances alfombra
  for (let i = 37; i <= 48; i++) {
    scene.load.image(
      `valorAlfombra${i.toString()}`,
      ROUTES.rutaRuletaValoresAlfombraChances +
        `/valorAlfombra${i.toString()}Resized.png`
    );
    scene.load.image(
      `valorAlfombra${i.toString()}Hover`,
      ROUTES.rutaRuletaValoresAlfombraChances +
        `/valorAlfombra${i.toString()}HoverResized.png`
    );
  }

  // Sexta Linea alfombra
  for (let i = 49; i <= 59; i++) {
    scene.load.image(
      `valorAlfombra${i.toString()}`,
      ROUTES.rutaRuletaValoresAlfombraSextaLinea +
        `/valorAlfombra${i.toString()}Resized.png`
    );
    scene.load.image(
      `valorAlfombra${i.toString()}Hover`,
      ROUTES.rutaRuletaValoresAlfombraSextaLinea +
        `/valorAlfombra${i.toString()}HoverResized.png`
    );
  }

  // Calle alfombra
  for (let i = 60; i <= 73; i++) {
    scene.load.image(
      `valorAlfombra${i.toString()}`,
      ROUTES.rutaRuletaValoresAlfombraCalle +
        `/valorAlfombra${i.toString()}Resized.png`
    );
    scene.load.image(
      `valorAlfombra${i.toString()}Hover`,
      ROUTES.rutaRuletaValoresAlfombraCalle +
        `/valorAlfombra${i.toString()}HoverResized.png`
    );
  }

  // Esquina alfombra
  for (let i = 74; i <= 96; i++) {
    scene.load.image(
      `valorAlfombra${i.toString()}`,
      ROUTES.rutaRuletaValoresAlfombraEsquina +
        `/valorAlfombra${i.toString()}Resized.png`
    );
    scene.load.image(
      `valorAlfombra${i.toString()}Hover`,
      ROUTES.rutaRuletaValoresAlfombraEsquina +
        `/valorAlfombra${i.toString()}HoverResized.png`
    );
  }

  // Dobles Horizontal alfombra
  for (let i = 97; i <= 132; i++) {
    scene.load.image(
      `valorAlfombra${i.toString()}`,
      ROUTES.rutaRuletaValoresAlfombraDoblesHorizontal +
        `/valorAlfombra${i.toString()}Resized.png`
    );
    scene.load.image(
      `valorAlfombra${i.toString()}Hover`,
      ROUTES.rutaRuletaValoresAlfombraDoblesHorizontal +
        `/valorAlfombra${i.toString()}HoverResized.png`
    );
  }

  // Dobles Vertical alfombra
  for (let i = 133; i <= 156; i++) {
    scene.load.image(
      `valorAlfombra${i.toString()}`,
      ROUTES.rutaRuletaValoresAlfombraDoblesVertical +
        `/valorAlfombra${i.toString()}Resized.png`
    );
    scene.load.image(
      `valorAlfombra${i.toString()}Hover`,
      ROUTES.rutaRuletaValoresAlfombraDoblesVertical +
        `/valorAlfombra${i.toString()}HoverResized.png`
    );
  }

}
